const scenarios = {
    liquidity_crisis: {
      1: {
        situation:
          "Market volatility spikes 40%. Three major institutional clients ($37.5B combined) submit redemption notices effective in 7 days. Underlying credit markets show severe stress with bid-ask spreads widening dramatically.",
        decision_point: "How do you manage the immediate liquidity demand?",
        options: [
          {
            id: "sell_liquid_assets",
            text: "Liquidate most liquid positions",
            consequences: { cash: 2000000, reputation: -15, operational_capacity: -10, stakeholder_confidence: -20 },
            description: "Fast cash generation but impacts all clients and may crystallize losses",
          },
          {
            id: "activate_credit_lines",
            text: "Draw on credit facilities",
            consequences: { cash: -500000, reputation: 5, operational_capacity: 0, stakeholder_confidence: 10 },
            description: "Preserves portfolios but increases leverage and cost",
          },
          {
            id: "implement_gates",
            text: "Invoke redemption gates",
            consequences: { cash: 0, reputation: -25, operational_capacity: 20, stakeholder_confidence: -30 },
            description: "Protects remaining investors but severe reputational damage",
          },
        ],
      },
      2: {
        situation:
          "Redemption deadline approaches. Media reports emerge about liquidity stress. Two additional clients ($8B) now questioning their investments. Credit rating agencies reviewing your firm.",
        decision_point: "How do you handle the escalating situation?",
        options: [
          {
            id: "transparent_communication",
            text: "Full transparency to all clients",
            consequences: { cash: 0, reputation: 10, operational_capacity: 0, stakeholder_confidence: -10 },
            description: "Builds trust long-term but may trigger more redemptions",
          },
          {
            id: "selective_disclosure",
            text: "Targeted communication to key clients",
            consequences: { cash: 0, reputation: -5, operational_capacity: 5, stakeholder_confidence: 5 },
            description: "Minimizes panic but risks regulatory scrutiny",
          },
          {
            id: "emergency_asset_sales",
            text: "Accelerate asset sales at discounts",
            consequences: { cash: 5000000, reputation: -20, operational_capacity: -30, stakeholder_confidence: -25 },
            description: "Solves immediate problem but destroys long-term value",
          },
        ],
      },
      3: {
        situation: "Credit agencies downgrade your firm's rating. Banks are requesting additional collateral for your credit lines. A major pension fund is considering a full redemption of $15B.",
        decision_point: "How do you stabilize the financial standing of the firm?",
        options: [
          {
            id: "emergency_merger",
            text: "Explore emergency merger with a stable competitor",
            consequences: { cash: 0, reputation: -30, operational_capacity: -40, stakeholder_confidence: -20 },
            description: "A last resort option that could provide stability but means losing independence.",
          },
          {
            id: "asset_restructure",
            text: "Announce a major fund restructuring and asset-class pivot",
            consequences: { cash: -2000000, reputation: 15, operational_capacity: -25, stakeholder_confidence: 20 },
            description: "Shows decisive action and a forward-looking strategy, but is costly and disrupts operations.",
          },
          {
            id: "secure_private_equity",
            text: "Seek a capital injection from a private equity firm",
            consequences: { cash: 8000000, reputation: -10, operational_capacity: 0, stakeholder_confidence: 15 },
            description: "Provides a significant cash buffer but comes with stringent terms and a loss of equity.",
          },
        ],
      },
      4: {
        situation: "Redemptions have stabilized but at 40% below previous AUM. Operating costs are now unsustainably high relative to revenue. Key talent is being poached by competitors.",
        decision_point: "What's your recovery strategy priority?",
        options: [
          {
            id: "cost_cutting",
            text: "Implement deep, firm-wide cost reduction (15% headcount)",
            consequences: { cash: 3000000, reputation: -15, operational_capacity: -30, stakeholder_confidence: 10 },
            description: "Improves financials and shows fiscal discipline, but severely hurts morale and capacity.",
          },
          {
            id: "innovation_push",
            text: "Launch new, innovative investment products to attract new capital",
            consequences: { cash: -4000000, reputation: 20, operational_capacity: -10, stakeholder_confidence: 25 },
            description: "A bold, forward-looking move to regain market position, but requires significant upfront investment.",
          },
          {
            id: "retain_talent",
            text: "Announce a key talent retention bonus program",
            consequences: { cash: -2500000, reputation: 10, operational_capacity: 5, stakeholder_confidence: 20 },
            description: "Stops the talent drain and signals commitment to the team, but is a significant cash expense.",
          },
        ],
      },
      5: {
        situation: "Six months later, the firm has survived. Investor confidence is slowly returning. Competition is intensifying for new mandates, and your firm is often viewed as a higher risk.",
        decision_point: "How do you position for the future to regain market trust?",
        options: [
          {
            id: "tech_transformation",
            text: "Invest heavily in risk and liquidity management technology",
            consequences: { cash: -5000000, reputation: 15, operational_capacity: 30, stakeholder_confidence: 20 },
            description: "Modernizes the firm and provides a tangible story of improvement, but requires significant capital.",
          },
          {
            id: "organic_growth",
            text: "Focus on slow, organic growth with existing clients and strategies",
            consequences: { cash: -500000, reputation: 20, operational_capacity: 10, stakeholder_confidence: 25 },
            description: "A traditional, low-risk approach emphasizing fundamentals and rebuilding trust over time.",
          },
           {
            id: "acquire_firm",
            text: "Acquire a smaller, stable firm with a strong performance record",
            consequences: { cash: -7000000, reputation: 25, operational_capacity: -15, stakeholder_confidence: 30 },
            description: "Quickly buys a good track record and new assets, but is very expensive and brings integration challenges.",
          },
        ],
      },
      6: {
        situation: "Final assessment period. The board is reviewing the crisis response effectiveness. New, stricter liquidity regulations are taking effect across the industry.",
        decision_point: "What permanent changes do you implement to prove resilience?",
        options: [
          {
            id: "fortress_balance",
            text: "Implement a 'fortress' balance sheet with higher-than-required cash reserves",
            consequences: { cash: -2000000, reputation: 30, operational_capacity: -5, stakeholder_confidence: 35 },
            description: "Provides maximum safety and is a strong signal to regulators, but reduces potential returns.",
          },
          {
            id: "dynamic_hedging",
            text: "Deploy a new, dynamic risk hedging system across all funds",
            consequences: { cash: -4000000, reputation: 20, operational_capacity: -15, stakeholder_confidence: 25 },
            description: "Offers advanced, modern protection but is complex and expensive to manage.",
          },
          {
            id: "new_c_suite_role",
            text: "Create a new C-Suite Chief Resilience Officer role",
            consequences: { cash: -1000000, reputation: 25, operational_capacity: 5, stakeholder_confidence: 30 },
            description: "Demonstrates a strong commitment to resilience at the highest level, creating accountability.",
          },
        ],
      },
    },
    nav_settlement_failure: {
      1: {
        situation:
          "Month-end pricing systems crash at 2 PM EST. 200+ funds need NAV calculations by 6 PM for settlement tomorrow. Backup systems are 72 hours behind on data feeds. Regulators require timely disclosure.",
        decision_point: "How do you handle the immediate NAV crisis?",
        options: [
          {
            id: "manual_calculation",
            text: "Deploy full team for manual NAV calculations using last available prices",
            consequences: { cash: -200000, reputation: -5, operational_capacity: -40, stakeholder_confidence: -10 },
            description: "Meets deadline but high error risk and operational strain.",
          },
          {
            id: "delay_nav_publication",
            text: "Notify regulators and clients of NAV delay due to system failure",
            consequences: { cash: -100000, reputation: -15, operational_capacity: 10, stakeholder_confidence: -20 },
            description: "Regulatory compliant but impacts client confidence and causes settlement failures.",
          },
          {
            id: "third_party_vendor",
            text: "Emergency contract with third-party calculation service",
            consequences: { cash: -1000000, reputation: 0, operational_capacity: -20, stakeholder_confidence: 5 },
            description: "Expensive but professional solution that contains the risk.",
          },
        ],
      },
      2: {
        situation:
          "NAV calculations were completed 8 hours late, causing settlement breaks for several institutional clients. Auditors are now formally questioning your control environment. IT estimates 48 hours for full system restoration.",
        decision_point: "How do you manage the immediate fallout?",
        options: [
          {
            id: "accelerate_it_recovery",
            text: "Bring in emergency IT contractors to expedite system recovery at 3x cost",
            consequences: { cash: -2000000, reputation: 5, operational_capacity: 30, stakeholder_confidence: 15 },
            description: "Expensive but demonstrates commitment to resolution and gets systems back faster.",
          },
          {
            id: "client_compensation",
            text: "Proactively communicate and offer compensation to affected clients",
            consequences: { cash: -1500000, reputation: 15, operational_capacity: -5, stakeholder_confidence: 25 },
            description: "Very expensive, but turns a negative into a potential positive for client relationships.",
          },
          {
            id: "implement_workarounds",
            text: "Create temporary manual processes for critical operations for the next 48 hours",
            consequences: { cash: -500000, reputation: -10, operational_capacity: -10, stakeholder_confidence: -5 },
            description: "Lower cost but maintains high operational risk and team burnout.",
          },
        ],
      },
      3: {
        situation: "The system is restored, but a forensic review reveals minor pricing errors in 15% of the manually calculated NAVs. These errors are small but material enough to require correction.",
        decision_point: "How do you address the pricing errors?",
        options: [
            {
                id: "restate_and_compensate",
                text: "Fully restate all affected NAVs and compensate all impacted clients",
                consequences: { cash: -2500000, reputation: 20, operational_capacity: -15, stakeholder_confidence: 25 },
                description: "The 'cleanest' option. Extremely expensive but shows full accountability and restores trust.",
            },
            {
                id: "materiality_threshold",
                text: "Only compensate clients whose losses exceed a set materiality threshold",
                consequences: { cash: -1000000, reputation: -10, operational_capacity: 0, stakeholder_confidence: -5 },
                description: "Saves money but can be perceived as nickel-and-diming and may lead to disputes.",
            },
            {
                id: "future_fee_credit",
                text: "Offer future fee credits instead of direct cash compensation",
                consequences: { cash: 0, reputation: 5, operational_capacity: 0, stakeholder_confidence: 10 },
                description: "Preserves cash but is a less direct form of compensation that some clients may reject.",
            },
        ]
      },
      4: {
        situation: "The regulator has launched a formal inquiry into the system failure and subsequent pricing errors, requesting extensive documentation on your BCP and control frameworks.",
        decision_point: "What is your primary stance with the regulator?",
        options: [
            {
                id: "full_proactive_cooperation",
                text: "Full cooperation, providing more documentation than requested",
                consequences: { cash: -500000, reputation: 15, operational_capacity: -20, stakeholder_confidence: 10 },
                description: "Resource-intensive but positions the firm as a transparent and responsible partner.",
            },
            {
                id: "hire_external_counsel",
                text: "Hire top-tier external legal counsel to manage all regulatory communication",
                consequences: { cash: -2000000, reputation: 5, operational_capacity: 0, stakeholder_confidence: 5 },
                description: "Very expensive but provides the best legal protection and signaling.",
            },
            {
                id: "internal_investigation_first",
                text: "Delay response while conducting a privileged internal investigation first",
                consequences: { cash: -1000000, reputation: -15, operational_capacity: -10, stakeholder_confidence: -20 },
                description: "Gives you more information before responding, but can be seen as stalling and uncooperative.",
            },
        ]
      },
      5: {
        situation: "The operational incident is over, but stakeholder confidence is shaken. It's time to invest in preventing a recurrence.",
        decision_point: "What is the most critical long-term investment?",
        options: [
            {
                id: "system_overhaul",
                text: "Full replacement of the legacy NAV calculation system",
                consequences: { cash: -8000000, reputation: 20, operational_capacity: 40, stakeholder_confidence: 30 },
                description: "The most expensive option, but permanently solves the root cause and is a powerful story for clients.",
            },
            {
                id: "dr_site_enhancement",
                text: "Enhance backup systems and build a hot-hot DR site",
                consequences: { cash: -4000000, reputation: 10, operational_capacity: 25, stakeholder_confidence: 20 },
                description: "A cheaper option that improves recovery time but doesn't fix the core legacy system.",
            },
            {
                id: "invest_in_automation",
                text: "Invest in AI-driven reconciliation and validation tools",
                consequences: { cash: -3000000, reputation: 15, operational_capacity: 35, stakeholder_confidence: 25 },
                description: "Reduces reliance on manual processes and improves accuracy, tackling the error problem.",
            },
        ]
      },
      6: {
        situation: "The firm has stabilized. You need to send a final, powerful message to the market and clients that the issues are resolved and controls are stronger than ever.",
        decision_point: "What is the best way to rebuild your technical reputation?",
        options: [
            {
                id: "soc2_audit",
                text: "Undergo a voluntary, independent SOC 2 Type II audit of your controls",
                consequences: { cash: -1500000, reputation: 30, operational_capacity: -5, stakeholder_confidence: 35 },
                description: "Provides a powerful, independent validation of your control environment to show clients.",
            },
            {
                id: "publish_whitepaper",
                text: "Publish a thought leadership whitepaper on operational resilience",
                consequences: { cash: -200000, reputation: 15, operational_capacity: 0, stakeholder_confidence: 20 },
                description: "Positions the firm as an expert, turning a weakness into a narrative strength.",
            },
            {
                id: "client_tech_summit",
                text: "Host a technology and resilience summit for your key clients",
                consequences: { cash: -1000000, reputation: 25, operational_capacity: 0, stakeholder_confidence: 30 },
                description: "A high-touch, transparent event to directly reassure your most important stakeholders.",
            },
        ]
      },
    },
    trading_system_outage: {
      1: {
        situation:
          "Trading systems are compromised during market open due to a zero-day exploit. $2B in client orders cannot be executed. The market is moving significantly against some positions.",
        decision_point: "How do you handle the trading crisis?",
        options: [
          {
            id: "manual_trading",
            text: "Execute critical trades manually via phone with prime brokers",
            consequences: { cash: -300000, reputation: -10, operational_capacity: -30, stakeholder_confidence: -15 },
            description: "Maintains some capability but is slow, error-prone, and has limited capacity.",
          },
          {
            id: "halt_all_trading",
            text: "Suspend all trading firm-wide until systems are fully restored",
            consequences: { cash: 0, reputation: -20, operational_capacity: -60, stakeholder_confidence: -25 },
            description: "Safest approach to prevent errors but creates significant market risk and client outrage.",
          },
          {
            id: "activate_dr_platform",
            text: "Activate disaster recovery trading platform immediately",
            consequences: { cash: -1000000, reputation: 5, operational_capacity: -20, stakeholder_confidence: 10 },
            description: "Maintains operations but has limited functionality and data may not be fully synced.",
          },
        ],
      },
      2: {
        situation: "The system remains down. Cybersecurity consultants confirm it was an external attack. Clients with trapped orders are threatening legal action over execution failures.",
        decision_point: "How do you manage client liabilities and communication?",
        options: [
            {
                id: "absorb_losses",
                text: "Announce the firm will absorb all demonstrable client losses",
                consequences: { cash: -5000000, reputation: 30, operational_capacity: 0, stakeholder_confidence: 40 },
                description: "Extremely expensive, but the ultimate act of goodwill that could save client relationships.",
            },
            {
                id: "invoke_force_majeure",
                text: "Invoke 'force majeure' clause in client agreements due to cyber attack",
                consequences: { cash: 0, reputation: -40, operational_capacity: 10, stakeholder_confidence: -50 },
                description: "Legally defensible and preserves all cash, but is seen as a betrayal and will likely lose clients.",
            },
            {
                id: "negotiate_settlements",
                text: "Negotiate settlements with the most vocal and largest clients",
                consequences: { cash: -2000000, reputation: -15, operational_capacity: 0, stakeholder_confidence: -10 },
                description: "A middle ground that contains the biggest risks but creates unequal treatment and risks leaks.",
            }
        ]
      },
      3: {
        situation: "Your cybersecurity insurer requires a decision on whether to pay the attacker's ransom demand to potentially receive a decryption key and restore systems faster.",
        decision_point: "Do you pay the ransom?",
        options: [
            {
                id: "pay_ransom",
                text: "Pay the ransom through a third-party negotiator",
                consequences: { cash: -3000000, reputation: -20, operational_capacity: 25, stakeholder_confidence: -15 },
                description: "Might get systems back online faster, but funds criminals and there's no guarantee it will work.",
            },
            {
                id: "refuse_ransom",
                text: "Refuse to pay and rely on backups and rebuilding",
                consequences: { cash: 0, reputation: 15, operational_capacity: -30, stakeholder_confidence: 10 },
                description: "The ethical choice, but guarantees a longer, more painful and expensive recovery period.",
            }
        ]
      },
      4: {
        situation: "Systems are being rebuilt from backups, but the process will take another 72 hours. Media has broken the story of the cyber attack, and regulators are requesting a formal briefing.",
        decision_point: "How do you manage the public and regulatory narrative?",
        options: [
            {
                id: "proactive_press_conference",
                text: "Hold a press conference with the CEO to control the narrative",
                consequences: { cash: -200000, reputation: 10, operational_capacity: -5, stakeholder_confidence: 5 },
                description: "Shows leadership and transparency, but opens the CEO to difficult questions.",
            },
            {
                id: "written_statements_only",
                text: "Issue only carefully worded written statements",
                consequences: { cash: 0, reputation: -10, operational_capacity: 0, stakeholder_confidence: -10 },
                description: "Minimizes risk of misstatement but can appear evasive and cold.",
            },
            {
                id: "brief_regulators_privately",
                text: "Focus on private regulator briefings and ignore the media",
                consequences: { cash: 0, reputation: -15, operational_capacity: 5, stakeholder_confidence: -5 },
                description: "Prioritizes the most powerful stakeholder but allows the public narrative to run wild.",
            }
        ]
      },
      5: {
        situation: "The trading systems are finally restored. Now begins the costly process of forensic audits, security upgrades, and regulatory fines.",
        decision_point: "What is the most critical post-incident investment?",
        options: [
            {
                id: "next_gen_security",
                text: "Overhaul entire cybersecurity stack with next-gen EDR and AI monitoring",
                consequences: { cash: -6000000, reputation: 20, operational_capacity: 15, stakeholder_confidence: 25 },
                description: "Highest possible cost, but the best protection and a powerful story for institutional clients.",
            },
            {
                id: "employee_training_program",
                text: "Implement a mandatory, firm-wide advanced cybersecurity training program",
                consequences: { cash: -1000000, reputation: 10, operational_capacity: 5, stakeholder_confidence: 15 },
                description: "Addresses the human element, which is often the weakest link, at a lower cost.",
            },
        ]
      },
      6: {
        situation: "The firm has weathered the storm. You need a final strategic action to signal to the market that you are stronger and more secure than before.",
        decision_point: "What is your capstone action?",
        options: [
            {
                id: "bug_bounty_program",
                text: "Launch a public bug bounty program to crowdsource vulnerability testing",
                consequences: { cash: -500000, reputation: 25, operational_capacity: 5, stakeholder_confidence: 30 },
                description: "A radical act of transparency that shows extreme confidence in your new security posture.",
            },
            {
                id: "secure_new_insurance",
                text: "Secure a larger, premium cybersecurity insurance policy and advertise it",
                consequences: { cash: -1500000, reputation: 15, operational_capacity: 0, stakeholder_confidence: 25 },
                description: "Uses a third-party financial commitment to signal that the risk is now considered low.",
            },
        ]
      },
    },
    regulatory_investigation: {
      1: {
        situation:
          "The SEC announces a formal investigation into potential front-running allegations from three years ago. Your firm's stock drops 10% and client onboarding is frozen pending review.",
        decision_point: "How do you respond to the initial announcement?",
        options: [
          {
            id: "full_cooperation",
            text: "Provide complete cooperation and launch a parallel internal investigation",
            consequences: { cash: -2000000, reputation: 10, operational_capacity: -20, stakeholder_confidence: 5 },
            description: "The 'by-the-book' approach. Signals integrity but incurs significant legal costs and resource drain.",
          },
          {
            id: "minimal_compliance",
            text: "Respond only to specific regulatory requests as required by law",
            consequences: { cash: -500000, reputation: -15, operational_capacity: -5, stakeholder_confidence: -20 },
            description: "Lower immediate cost and less disruption, but may prolong the investigation and appear obstructionist.",
          },
          {
            id: "aggressive_denial",
            text: "Issue a strong public denial of all allegations",
            consequences: { cash: -100000, reputation: -5, operational_capacity: 0, stakeholder_confidence: 10 },
            description: "Projects confidence to the market, but is a very high-risk strategy if any wrongdoing is found.",
          },
        ],
      },
      2: {
        situation: "The investigation drags on. Key employees are being deposed, hurting morale and productivity. Competitors are using the uncertainty to poach your clients.",
        decision_point: "How do you manage the internal and external pressure?",
        options: [
            {
                id: "provide_counsel_all",
                text: "Provide independent legal counsel for all deposed employees",
                consequences: { cash: -1500000, reputation: 10, operational_capacity: 5, stakeholder_confidence: 15 },
                description: "Expensive, but demonstrates loyalty to the team and improves morale and cooperation.",
            },
            {
                id: "proactive_client_outreach",
                text: "Launch a proactive client outreach campaign with fee concessions for loyalty",
                consequences: { cash: -3000000, reputation: 15, operational_capacity: -5, stakeholder_confidence: 20 },
                description: "A costly effort to lock in key clients, but may signal desperation to the market.",
            },
            {
                id: "go_silent",
                text: "Maintain public silence and focus only on the legal process",
                consequences: { cash: 0, reputation: -20, operational_capacity: 0, stakeholder_confidence: -25 },
                description: "Prevents missteps, but creates an information vacuum that competitors and media will fill.",
            },
        ]
      },
      3: {
        situation: "A key document is leaked to the press, which appears to show questionable trading practices. The story is the top headline on financial news.",
        decision_point: "How do you respond to the media crisis?",
        options: [
            {
                id: "ceo_interview",
                text: "Put the CEO on live television to address the allegations directly",
                consequences: { cash: -100000, reputation: 15, operational_capacity: 0, stakeholder_confidence: 5 },
                description: "High-risk, high-reward. A strong performance can restore confidence; a poor one can be disastrous.",
            },
            {
                id: "hire_crisis_pr",
                text: "Hire a top-tier crisis PR firm to manage the narrative",
                consequences: { cash: -1000000, reputation: 10, operational_capacity: 0, stakeholder_confidence: 0 },
                description: "Expensive, but brings expert guidance on how to navigate the media storm.",
            },
            {
                id: "ignore_and_discredit",
                text: "Issue a statement calling the document 'out of context' and refuse further comment",
                consequences: { cash: 0, reputation: -15, operational_capacity: 0, stakeholder_confidence: -10 },
                description: "A low-cost attempt to discredit the story, but may lack credibility.",
            },
        ]
      },
      4: {
        situation: "The regulator offers a settlement: a significant fine and the requirement to hire an independent monitor, but no admission of guilt.",
        decision_point: "Do you accept the settlement?",
        options: [
            {
                id: "accept_settlement",
                text: "Accept the settlement to end the uncertainty",
                consequences: { cash: -10000000, reputation: 5, operational_capacity: -10, stakeholder_confidence: 25 },
                description: "A massive cash hit, but it closes a damaging chapter and allows the firm to move on.",
            },
            {
                id: "fight_in_court",
                text: "Reject the settlement and fight the charges in court",
                consequences: { cash: -3000000, reputation: -25, operational_capacity: -15, stakeholder_confidence: -30 },
                description: "Avoids the large fine if you win, but guarantees years of costly litigation and negative headlines.",
            },
        ]
      },
      5: {
        situation: "With the legal issues resolved, the client onboarding freeze is lifted. However, your firm's reputation for compliance is now damaged.",
        decision_point: "What is the first step to rebuilding your compliance reputation?",
        options: [
            {
                id: "new_cco",
                text: "Hire a new, high-profile Chief Compliance Officer from a regulator",
                consequences: { cash: -1500000, reputation: 25, operational_capacity: 5, stakeholder_confidence: 30 },
                description: "A powerful signal to the market that compliance is now the top priority.",
            },
            {
                id: "compliance_tech_spend",
                text: "Announce a $10M investment in new compliance and surveillance technology",
                consequences: { cash: -10000000, reputation: 20, operational_capacity: 15, stakeholder_confidence: 25 },
                description: "Demonstrates a significant financial commitment to preventing future issues.",
            },
        ]
      },
      6: {
        situation: "One year later, the firm is on the road to recovery. You want to make a final gesture to prove the 'new chapter' for the firm is real.",
        decision_point: "What is the final capstone action?",
        options: [
            {
                id: "ethics_committee",
                text: "Establish a new, independent Board Committee on Business Standards and Ethics",
                consequences: { cash: -500000, reputation: 20, operational_capacity: 0, stakeholder_confidence: 25 },
                description: "Embeds accountability at the highest level of governance.",
            },
            {
                id: "clawback_policy",
                text: "Implement and publicize a strict new executive compensation clawback policy for misconduct",
                consequences: { cash: 0, reputation: 25, operational_capacity: 0, stakeholder_confidence: 30 },
                description: "A no-cost policy change that strongly aligns leadership incentives with ethical conduct.",
            },
        ]
      },
    },
    key_client_withdrawal: {
      1: {
        situation:
          "Your three largest institutional clients announce the withdrawal of $25B (20% of AUM) citing a year of underperformance. The 90-day notice period begins. Other clients are now expressing concerns.",
        decision_point: "What is your immediate response to the departing clients?",
        options: [
          {
            id: "fee_concessions",
            text: "Offer significant, multi-year fee reductions to convince them to stay",
            consequences: { cash: -5000000, reputation: 5, operational_capacity: 0, stakeholder_confidence: -10 },
            description: "May retain AUM but sets a dangerous precedent and significantly hurts profitability.",
          },
          {
            id: "managed_transition",
            text: "Work collaboratively on a smooth asset transition to minimize market impact",
            consequences: { cash: -1000000, reputation: 20, operational_capacity: -25, stakeholder_confidence: 5 },
            description: "A professional approach that builds goodwill, but accepts the massive loss of AUM.",
          },
          {
            id: "aggressive_retention",
            text: "Deploy senior leadership for intensive, last-ditch retention meetings",
            consequences: { cash: -500000, reputation: -5, operational_capacity: -10, stakeholder_confidence: 10 },
            description: "Shows commitment, but has a low probability of success and distracts leadership from other clients.",
          },
        ],
      },
      2: {
        situation: "The news has leaked. Competitors are actively targeting your other clients, citing your underperformance and the recent major withdrawals as reasons to leave.",
        decision_point: "How do you shore up your remaining client base?",
        options: [
            {
                id: "proactive_fee_cut",
                text: "Offer a proactive, firm-wide fee reduction for all clients for one year",
                consequences: { cash: -8000000, reputation: 25, operational_capacity: 0, stakeholder_confidence: 30 },
                description: "A bold and extremely expensive move to signal confidence and reward loyalty.",
            },
            {
                id: "investment_team_shakeup",
                text: "Announce a shakeup of the investment management team and process",
                consequences: { cash: -1000000, reputation: 10, operational_capacity: -15, stakeholder_confidence: 15 },
                description: "Shows you are addressing the root cause (performance), but can create internal instability.",
            },
            {
                id: "roadshow",
                text: "Launch a global roadshow for top executives to meet with key clients",
                consequences: { cash: -2000000, reputation: 15, operational_capacity: -10, stakeholder_confidence: 25 },
                description: "High-touch and reassuring, but very costly in time and money.",
            },
        ]
      },
      3: {
        situation: "The AUM loss is now reflected in public filings. Your firm's stock price has dropped 20%, and analysts are questioning your growth strategy.",
        decision_point: "How do you manage the market narrative?",
        options: [
            {
                id: "stock_buyback",
                text: "Announce an aggressive stock buyback program",
                consequences: { cash: -10000000, reputation: 10, operational_capacity: 0, stakeholder_confidence: 15 },
                description: "A strong signal of confidence from management, but a massive use of cash reserves.",
            },
            {
                id: "announce_cost_cutting",
                text: "Announce a major cost-cutting initiative to protect profit margins",
                consequences: { cash: 2000000, reputation: -10, operational_capacity: -20, stakeholder_confidence: -5 },
                description: "Reassures shareholders on profitability but can signal to clients that the firm is shrinking.",
            },
            {
                id: "new_strategy_announcement",
                text: "Hold an investor day to announce a new, long-term growth strategy",
                consequences: { cash: -500000, reputation: 15, operational_capacity: -5, stakeholder_confidence: 20 },
                description: "Shifts the narrative from the loss to the future, but requires a credible plan.",
            },
        ]
      },
      4: {
        situation: "With a smaller AUM base, your firm's operational costs per asset are now too high. You need to right-size the organization.",
        decision_point: "How do you restructure the firm?",
        options: [
            {
                id: "targeted_layoffs",
                text: "Conduct targeted layoffs in underperforming or non-core divisions",
                consequences: { cash: 4000000, reputation: -10, operational_capacity: -15, stakeholder_confidence: 0 },
                description: "A painful but necessary step to align costs with revenue, directly impacting morale.",
            },
            {
                id: "sell_division",
                text: "Sell a non-core business division to a competitor",
                consequences: { cash: 6000000, reputation: 5, operational_capacity: -25, stakeholder_confidence: 10 },
                description: "Raises significant cash and sharpens focus, but reduces the firm's overall footprint.",
            },
        ]
      },
      5: {
        situation: "The firm is now smaller, leaner, but has lost market momentum. You need to restart the growth engine.",
        decision_point: "What is your primary growth strategy?",
        options: [
            {
                id: "acquire_boutique",
                text: "Acquire a small, high-performing boutique investment firm",
                consequences: { cash: -7000000, reputation: 15, operational_capacity: -10, stakeholder_confidence: 20 },
                description: "Buys immediate performance and talent, but is expensive and has integration risks.",
            },
            {
                id: "launch_new_fund_type",
                text: "Launch into a new, high-growth asset class (e.g., private credit)",
                consequences: { cash: -4000000, reputation: 10, operational_capacity: -5, stakeholder_confidence: 15 },
                description: "A bold move to capture a new market, but requires new expertise and significant investment.",
            },
            {
                id: "focus_on_core",
                text: "Double down on your core, flagship products to win back market share",
                consequences: { cash: -1000000, reputation: 5, operational_capacity: 0, stakeholder_confidence: 10 },
                description: "A lower-risk strategy focused on fixing the original problem, but growth may be slow.",
            },
        ]
      },
      6: {
        situation: "One year after the withdrawals, the firm has stabilized. It's time to set the strategic direction for the next five years.",
        decision_point: "What is the long-term vision for the firm?",
        options: [
            {
                id: "rebrand_specialist",
                text: "Rebrand the firm as a specialist, boutique manager",
                consequences: { cash: -2000000, reputation: 10, operational_capacity: 0, stakeholder_confidence: 15 },
                description: "Embraces the new, smaller size with a focused brand identity.",
            },
            {
                id: "path_to_regain_scale",
                text: "Announce a 5-year plan to regain scale through aggressive marketing and hiring",
                consequences: { cash: -6000000, reputation: 15, operational_capacity: 5, stakeholder_confidence: 20 },
                description: "Signals ambition and a return to growth, but is very expensive and resource-intensive.",
            },
        ]
      },
    },
};

export default scenarios;
